import {ScrapingUtils} from "../../../utils/scraping.utils";
import {ComparedValuePercentChange} from "../../modules/common/ComparedValue";
import * as React from "react";
import {getMetricFromTotals} from "../MetricsComparison/MetricsComparisonHelpers";
import {MuiDataGrid} from "@leap4/frontend";
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

export enum TableCellType {
    PartnersComboTable = "partnersComboTable",
    TagsComboTable = "tagsComboTable"
}

interface ITableCellProps {
    compareData: any,
    selectedData: GridRenderCellParams,
    metricEnum: string,
    tableCellType?: TableCellType
}

export const TableCellWithCompare = (props: ITableCellProps) => {

// if(props.metricEnum===EntitiesProperties.NUMERIC.ALL.IMPRESSIONS) console.log({props})
    const {compareData, selectedData, metricEnum, tableCellType} = props
    const searchAlgorithem = tableCellType === TableCellType.PartnersComboTable ? () => {
            return compareData.find(o => o.demandPartner + o.supplyPartner === selectedData.id)?.totals
                || 0
        }
        :
        () => {
            return compareData.find(o => o?._id === selectedData.id)?.totals ||
                compareData.find(o => o.demandTag?._id?.toString() + o.supplyTag?._id?.toString() === selectedData.id)?.totals ||
                compareData.find(o => o?.tag === selectedData?.id)?.totals  // adServerTags
                || 0
        }
    const totalsOfCompared = searchAlgorithem()
    const metricAtSelectedTime = +selectedData.value
    const metricAtComparedTime = getMetricFromTotals(metricEnum, totalsOfCompared)
    const percentChange = (metricAtSelectedTime / metricAtComparedTime) * 100 - 100
    return (
        <div style={{display: 'flex', gap: '8px', justifyContent: 'flex-start', alignItems: 'center', width: '100%', paddingRight: '8px'}}>
            <span style={{minWidth: '80px', textAlign: 'right'}}>{ScrapingUtils.addSignsToMetricValue(metricEnum, metricAtSelectedTime as number)}</span>
            <span style={{minWidth: '70px', textAlign: 'left'}}>{Boolean(metricAtSelectedTime) && Boolean(metricAtComparedTime) && <ComparedValuePercentChange
                percentChange={percentChange}/>}</span>
        </div>
    )
}